<template>
  <div class="goods">
    <detail></detail>
  </div>
</template>

<script>
import Detail from './Detail2'

export default {
  // components: {language},
  data() {
    return {};
  },
  components:{Detail},
  computed: {},
  destroyed() {},
  created() {},
  methods: {}
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/index/detail/newDetail.vue